import { phoneInputHandler } from '../../../../templates/main/phoneInputHandler';
import { waveEffect } from '../../../../templates/main/waveEffect';
export const Form = {
    data: () => ({
        formData: {
            form_text_28: '',
            form_text_29: '',
            form_textarea_30: '', // Добавлен комментарий
            model: '', // Добавлено поле для выбора модели
        },
        spinner: false,
        submited: false,
        countdown: 30, // Добавлен отсчет времени
        intervalId: null, // Для хранения идентификатора интервала
        phoneError: false,
        catalog: [],
        activeModelId: null,
        siteBrand: window.SITE_BRAND || 'Cukurova',
    }),
    methods: {
        send: function (e) {
            e.preventDefault();

            // Проверка заполненности поля телефона и длины номера
            const phoneNumber = this.formData.form_text_29.replace(/\D/g, ''); // Убираем все нецифровые символы
            if (phoneNumber.length < 9) { // Проверяем длину номера
                this.phoneError = true; // Устанавливаем ошибку телефона
                return;
            }
            this.phoneError = false; // Сбрасываем ошибку телефона

            this.spinner = true; // Включаем индикатор загрузки перед отправкой данных
            BX.ajax.runComponentAction('vv:forms', 'save', {
                mode: 'class',
                data: {data: {fields: this.formData, form_id: 'callback'}},
            }).then((response) => {
                this.spinner = false; // Выключаем индикатор загрузки после получения ответа
                if(response.data.status === 'success') {
                    // При успешной отправке сохраняем текущее время в localStorage
                    const now = new Date().getTime();
                    localStorage.setItem('lastFormZakazSubmitTime', now);
                    this.submited = true; // Показываем сообщение об успешной отправке
                    ym(window.YM_ID, 'reachGoal', 'get_price');
                    this.startCountdown(); // Запускаем отсчет
                } else {
                    console.error("Ошибка при отправке данных", response.data.message);
                }
            });
        },
        getCatalog: function (){
            BX.ajax.runComponentAction('vv:forms', 'getCatalog', {
                mode: 'class',
                data: {data: ''},
            }).then((response) => {
                if(response.status === 'success') {
                    this.catalog = response.data;
                }
            });
        },
        handlePhoneInput: function () {
            const phoneNumber = this.formData.form_text_29.replace(/\D/g, ''); // Убираем все нецифровые символы
            if (phoneNumber.length >= 9) {
                this.phoneError = false; // Убираем ошибку при вводе достаточного количества цифр
            }
        },
        startCountdown: function() {
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.clearForm();
                }
            }, 1000);
        },
        clearForm: function() {
            localStorage.removeItem('lastFormZakazSubmitTime'); // Очищаем запись в localStorage
            clearInterval(this.intervalId); // Очищаем интервал
            this.formData = {
                form_text_28: '',
                form_text_29: '',
                form_textarea_30: '',
                model: '',
            };
            this.activeModelId = null;
            this.submited = false;
            this.countdown = 30; // Сбрасываем отсчет
        },
        selectModel: function (id) {
            this.formData.model = id;
            this.activeModelId = id;
        }
    },
    mounted () {
        phoneInputHandler();
        waveEffect();
        this.getCatalog();
        const lastSubmitTime = localStorage.getItem('lastFormZakazSubmitTime');
        if (lastSubmitTime) {
            const now = new Date().getTime();
            const diff = now - lastSubmitTime;
            const remainingTime = 30 - Math.floor(diff / 1000);
            if (remainingTime > 0) {
                this.countdown = remainingTime;
                this.submited = true; // Предполагаем, что сообщение "Отправлено" должно отображаться
                this.startCountdown();
            }
        }
    },
    template: `<div class="lizing-form-main-page">
                    <div class="container">
                        <h2 class="lizing-form-main-page__name">Заказать спецтехнику <span>{{ siteBrand }}!</span></h2>
                        <p class="lizing-form-main-page__text">Оставьте свои контактные данные и Вам перезвоним, ответив на все возникшие вопросы.</p>
                        <div class="lizing-form-main-page__layout">
                            <form action="" class="form" @submit="send">
                            <div class="form-catalog">
                                <div class="form-catalog__title">Какая модель интересует?</div>
                                <div class="form-catalog__list">
                                    <template v-for="item in catalog">
                                        <div :class="['form-catalog__item', {'active': item.id === activeModelId}]" @click="selectModel(item.id)">
                                            <img class="form-catalog__picture" :src="item.picture" alt="">
                                            <div class="form-catalog__name">{{item.name}}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div :class="['form__single', {'form__single--error': phoneError}]">
                                <div class="form__fields form__fields--2">
<!--                                    <div class="form__group">-->
<!--                                        <label :for="formData.form_text_28" class="form__label">Как к Вам обращаться?</label>-->
<!--                                        <input type="text" :class="['form__field', {'form__field&#45;&#45;disabled': (spinner || submited)}]" v-model="formData.form_text_28" placeholder="Имя">-->
<!--                                    </div>-->
                                    <div class="form__group">
                                        <label :for="formData.phone" class="form__label">Ваш номер телефона</label>
                                        <input type="text" :class="['form__field', 'js-phone', {'form__field--disabled': (spinner || submited)}, {'form__field--error': phoneError}]" v-model="formData.form_text_29" @input="handlePhoneInput" placeholder="+7 (___) ___ __ __">
                                        <div v-if="phoneError" class="form__message-error">Поле обязательно к заполнению</div>
                                    </div>
                                </div>
<!--                                <div class="form__fields form__fields&#45;&#45;1">-->
<!--                                    <div class="form__group">-->
<!--                                        <label :for="formData.phone" class="form__label">Комментарий к заявке</label>-->
<!--                                        <textarea :class="['form__textarea', {'form__field&#45;&#45;disabled': (spinner || submited)}]" v-model="formData.form_textarea_30" name="" id="" cols="30" rows="10" placeholder="Комментарий"></textarea>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="form__fields form-protection__stack">
                                    <div class="form__group">
                                        <p class="form__conf">Нажимая кнопку "Отправить" Вы соглашаетесь с <a href="/conf/">Политикой конфиденциальности</a> </p>
                                    </div>
                                    <div class="form__group">
                                        <div v-if="submited" class="form__submited">
                                            <span>Отправлено</span>
                                            <svg width="13.125000" height="13.125000" viewBox="0 0 13.125 13.125" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <path id="path" d="M6.5625 13.125C2.94336 13.125 0 10.1813 0 6.5625C0 2.94373 2.94336 0 6.5625 0C8.5625 0 10.4287 0.895264 11.6826 2.45667C11.832 2.64331 11.8174 2.91284 11.6484 3.08154L5.95605 8.76892C5.77344 8.95215 5.47656 8.95215 5.29395 8.76892L2.9502 6.42517C2.7666 6.24182 2.7666 5.94568 2.9502 5.76233C3.13281 5.5791 3.42969 5.5791 3.6123 5.76233L5.625 7.77466L10.6768 2.72668C9.61426 1.58484 8.13574 0.9375 6.5625 0.9375C3.46094 0.9375 0.9375 3.46082 0.9375 6.5625C0.9375 9.66418 3.46094 12.1875 6.5625 12.1875C9.66406 12.1875 12.1875 9.66418 12.1875 6.5625C12.1875 5.97192 12.0967 5.39062 11.918 4.83521C11.8379 4.58911 11.9727 4.32471 12.2197 4.245C12.4688 4.16577 12.7295 4.30078 12.8096 4.54736C13.0186 5.19568 13.125 5.87341 13.125 6.5625C13.125 10.1813 10.1816 13.125 6.5625 13.125Z" fill="#ffffff" fill-opacity="1.000000" fill-rule="nonzero"></path>
                                            </svg>
                                        </div>
                                        <div class="form__sending" v-if="spinner">
                                            <div class="form__spinner"><div></div><div></div><div></div><div></div></div>
                                        </div>
                                        <button v-if="!spinner && !submited" type="submit" class="form__submit btn">Отправить</button>
                                    </div>
                                </div>
                                <div v-if="submited" class="form__disabled-time">Форму можно повторно отправить через {{ countdown }} сек.</div>
                            </div>
                            </form>
                            <div class="order-blueprint" aria-hidden="true">
                                <img class="order-blueprint__image" src="/local/images/form-order-blueprint.png" alt="" width="1672" height="941" loading="lazy" decoding="async">
                            </div>
                        </div>
                    </div>
                </div>`
};
